//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default{
		name:'result',
		data(){
			return{
				result_show:false,
				item_data:{},//奖品
				draw:new Audio(require('../../../resources/audio/draw.mp3')),
				Gold:false
			}
		},
		methods:{
			show(item){
				if(item.isGold == 1){
					this.Gold = true
				}else{
					this.$emit('setGold')
				}
				this.item_data = item
				this.result_show = true
				this.draw.play()
			},
			
			//状态
			setGold(){
				this.$emit('setGold')
				this.Gold = false
			},
			
			close(){
				this.result_show = false
				this.draw.pause()
				this.draw.load()
				this.Gold = false
			}
		}
	}
